import coxsbazar from '../../Image/coxsBazar.png';
import Sreemongol from '../../Image/Sreemongol.png';
import sundorbon from '../../Image/sundorbon.png';

export const  Destination = [
    {
        key: 0,
        name: "COX'S BAZAR",
        details: "Cox's Bazar (Bengali: কক্সবাজার, pronounced [kɔksbadʒaɾ]) is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it is infamous for the largest refugee camp in the world.",
        image: coxsbazar
    },
    {
        key: 1,
        name: "SREEMONGL",
        details: "Sreemangal is situated in Moulvibazar district in sylhet division. Sreemangal is an Upazila. It is famous for tea garden. Rain all time occurs here. Nature has adorned sreemangal with green tress.",
        image: Sreemongol
    },
    {
        key: 2,
        name: "SUNDORBAN",
        details: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh. ",
        image: sundorbon
    }
]

export default Destination;